import { PRODUCT_TYPE } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/productType'

import colors from '../../styles/_0colors.scss'

export interface ProductTypeColors {
  primaryAction: string
  primaryDark?: string
  dividerPrimary?: string
  textSecondary?: string
}

/**
 * Get colors based on product type
 * This function provides a scalable way to handle colors for different product types
 */
export const getProductTypeColors = (productType?: PRODUCT_TYPE, isAuroraTheme?: boolean): ProductTypeColors => {
  switch (productType) {
    case PRODUCT_TYPE.SELECT:
      return {
        primaryAction: colors.primary_action_lyra_select,
        primaryDark: colors.primary_dark_lyra_select,
      }
    case PRODUCT_TYPE.WFMH:
    default:
      if (isAuroraTheme) {
        return {
          primaryAction: colors.primary_action_aurora,
          dividerPrimary: colors.divider_primary_aurora_light,
          textSecondary: colors.text_secondary_aurora_light,
        }
      }
      return {
        primaryAction: colors.x_primary_action,
        primaryDark: colors.x_primary_dark,
      }
  }
}

/**
 * Check if a product type uses custom colors (not WFMH default)
 */
export const hasCustomColors = (productType?: string, isAuroraTheme?: boolean): boolean => {
  return (productType !== undefined && productType !== PRODUCT_TYPE.WFMH) || !!isAuroraTheme
}

/**
 * Resolve subscale chart line/legend color for the active context:
 * - provider portal uses providerPortal palette
 * - client apps (lyrahealthwebapp / lyraweb-mobile) use light or dark depending on user theme
 */
export const getSubscaleColor = (
  subscaleColors: { light: string; dark: string; providerPortal: string },
  { isProviderPortal, isDarkMode }: { isProviderPortal?: boolean; isDarkMode?: boolean },
): string => {
  if (isProviderPortal) return subscaleColors.providerPortal
  return isDarkMode ? subscaleColors.dark : subscaleColors.light
}
